export default __webpack_public_path__ + "static/media/Logo.f74efbe7.png";